import { render, staticRenderFns } from "./NewAppointmentDialog.vue?vue&type=template&id=105a8f16"
import script from "./NewAppointmentDialog.vue?vue&type=script&lang=js"
export * from "./NewAppointmentDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports